export default {
    name: 'retaking-history',
    props: {
        history: {
            required: true,
            type: Array
        },
        homeWork: {
            required: true,
            type: Object,
        },
    }
};
